import {
  SPG_WIDGET,
  SPG_WIDGET_ITEM_CODE,
  SPG_WIDGET_MODULE_CODE,
  SPG_WIDGET_MODULE_ITEM_CODE,
} from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import SPGWidget from './index';
import SPGWidgetThunk from './thunk';

const module: ModulesList = {
  [SPG_WIDGET]: {
    path: '/spg/:locationCode/:widgetCode',
    component: SPGWidget,
    thunk: SPGWidgetThunk,
  } as Module,
  [SPG_WIDGET_MODULE_CODE]: {
    path: '/spg/:locationCode/:widgetCode/:moduleCode',
    component: SPGWidget,
    thunk: SPGWidgetThunk,
  } as Module,
  [SPG_WIDGET_MODULE_ITEM_CODE]: {
    path: '/spg/:locationCode/:widgetCode/:moduleCode/item/:itemCode/',
    component: SPGWidget,
    thunk: SPGWidgetThunk,
  } as Module,
  [SPG_WIDGET_ITEM_CODE]: {
    path: '/spg/:locationCode/:widgetCode/item/:itemCode/',
    component: SPGWidget,
    thunk: SPGWidgetThunk,
  } as Module,
};

export default module;
